import {
  Component,
  OnInit,
  OnDestroy,
  inject,
  Inject,
  PLATFORM_ID,
  ChangeDetectionStrategy,
  ChangeDetectorRef
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Subscription } from 'rxjs';
import {
  SubscriptionBannerService,
  SubscriptionStatus
} from '../../service/subscription-banner-service';

@Component({
  selector: 'app-subscription-banner',
  standalone: false,
  template: `
    <div
      *ngIf="showBanner && status"
      class="subscription-banner"
      [class.subscription-banner--critical]="status.severity === 'critical'"
      [class.subscription-banner--warning]="status.severity === 'warning'"
      role="alert"
      aria-live="assertive"
    >
      <div class="subscription-banner__content">
        <div class="subscription-banner__icon-wrap">
          <mat-icon class="subscription-banner__icon">
            {{ status.severity === 'critical' ? 'error_outline' : 'warning_amber' }}
          </mat-icon>
        </div>
        <div class="subscription-banner__text">
          <span class="subscription-banner__label" *ngIf="status.severity === 'critical'">
            Action Required
          </span>
          <span class="subscription-banner__label" *ngIf="status.severity === 'warning'">
            Heads Up
          </span>
          <span class="subscription-banner__message">{{ status.message }}</span>
        </div>
        <button
          class="subscription-banner__dismiss"
          (click)="dismiss()"
          aria-label="Dismiss subscription notice"
          mat-icon-button
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  `,
  styleUrls: ['./subscription-banner.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubscriptionBanner implements OnInit, OnDestroy {
  private bannerService = inject(SubscriptionBannerService);
  private cd = inject(ChangeDetectorRef);
  private isBrowser: boolean;
  private sub!: Subscription;

  status: SubscriptionStatus | null = null;
  showBanner = false;

  constructor(@Inject(PLATFORM_ID) platformId: Object) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit(): void {
    if (!this.isBrowser) return;

    // Kick off the subscription check
    this.bannerService.checkSubscriptionStatus().subscribe();

    // React to status changes
    this.sub = this.bannerService.status$.subscribe((s) => {
      this.status = s;
      this.showBanner =
        s.severity !== 'none' && !this.bannerService.isDismissed;
      this.cd.markForCheck();
    });
  }

  dismiss(): void {
    this.bannerService.dismissBanner();
    this.showBanner = false;
    this.cd.markForCheck();
  }

  ngOnDestroy(): void {
    if (this.sub) this.sub.unsubscribe();
  }
}
